<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav class="pull-left">

      </nav>
      <div class="copyright pull-right">
        Copyright 2020 Retail Media Solution, Inc. All Rights Reserved
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>
  .test_tr {
    background-color: #b32c2c !important;
  }
</style>
